module.exports = "/images/Arcade.svg?3ef2a5b28ae8465077fe91dc30690a3b";